export default function mutations() {
	return {
		setCurrentUser: (state, user) => {
			state.user = user;
		},
        setUserList: (state, userList) => {
            state.userList = userList;
        },
        setBIKAListResponse: (state, payload) => {
            state.BIKAListResponse = payload;
        },
        setSimpleRegistration: (state, payload) => {
            state.simpleRegistration = payload;
        },
        setSimpleRegistrationEmail: (state, payload) => {
            state.simpleRegistrationEmail = payload;
        },
	};
}
